"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const RemoveTemplate = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "m17.614 5.72 1.77-1.77-1.768-1.767L19.031.77l1.767 1.767 1.769-1.77 1.414 1.415-1.77 1.77 1.767 1.766-1.414 1.414-1.767-1.767-1.77 1.77-1.413-1.414ZM5 3h3v2H5a1 1 0 0 0-1 1v2H2V6a3 3 0 0 1 3-3Zm-3 7h2v4H2v-4Zm0 6v2a3 3 0 0 0 3 3h3v-2H5a1 1 0 0 1-1-1v-2H2Zm8-11V3h6v2h-6Zm6 16h3a3 3 0 0 0 3-3v-2h-2v2a1 1 0 0 1-1 1h-3v2Zm6-12v5h-2V9h2Zm-8 12v-2h-4v2h4Zm2-12h1v2H7V9h9Zm-7 3h6v2H9v-2Z"
      }
    )
  );
};
export default RemoveTemplate;
